import { api, fetcher, wrappedCollectionFetcher } from "services/api.service";
import { defaultAllowedMovement, AllowedMovement } from "types/locationManagement/allowedMovement";
import { LocationManagementLocationType } from "types/locationManagement/locationType";
import { redirect } from "react-router-dom";
import { withActionErrorAlert } from "utils/withActionError";
import { withAuth } from "routes/utils/withAuth";

export const loader = withAuth(async ({ params }: { params: Record<string, string | undefined> }) => {
  let allowedMovement = defaultAllowedMovement;
  if (params.allowedMovementId) {
    const res = await fetcher<AllowedMovement>(`/location_management/allowed_movements/${params.allowedMovementId}`);
    allowedMovement = res;
  }
  const locationTypesRes = await wrappedCollectionFetcher<LocationManagementLocationType>(
    "/location_management/location_types?page[size]=100",
  );
  const locationTypes = locationTypesRes.rows || [];
  return { allowedMovement, locationTypes };
});

export async function action({ request, params }: { request: Request; params: Record<string, string | undefined> }) {
  const formData = await request.formData();
  const res = await withActionErrorAlert(() =>
    api.request({
      method: "PUT",
      url: `/location_management/allowed_movements/${params.allowedMovementId}`,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    }),
  );
  if (res?.status === 200) {
    return redirect("/allowed-movements");
  }
  return res;
}
